// @flow

import React from 'react';
import { connect } from 'react-redux';
import {
  getAvailableLabel,
  getOccasionLinkTextSingle,
  getOccasionLinkTextPlural,
} from '../../../store/componentSettings/selectors/pdbInfoSettings';
import {
  Occassions as OccassionsComponent,
  AvailableText,
  OccassionsLink,
} from './atoms';

type OwnProps = {|
  linkToOccassions: ?string,
  numberOfOccasions: ?number,
|};

type StateProps = {|
  availableLabel: string,
  occasionLinkTextSingle: string,
  occasionLinkTextPlural: string,
|};

type Props = OwnProps & StateProps;

const Occasions = ({
  availableLabel,
  linkToOccassions,
  numberOfOccasions,
  occasionLinkTextPlural,
  occasionLinkTextSingle,
}: Props) => (
  <OccassionsComponent>
    <AvailableText>
      {availableLabel}
&nbsp;
    </AvailableText>
    <OccassionsLink href={linkToOccassions}>
      {numberOfOccasions}
      &nbsp;
      {numberOfOccasions === 1 ? occasionLinkTextSingle : occasionLinkTextPlural}
    </OccassionsLink>
  </OccassionsComponent>
);

const mapStateToProps = (state): StateProps => ({
  availableLabel: getAvailableLabel(state),
  occasionLinkTextSingle: getOccasionLinkTextSingle(state),
  occasionLinkTextPlural: getOccasionLinkTextPlural(state),
});


export default connect<any, OwnProps, StateProps, any, any, any>(mapStateToProps)(Occasions);
